import { Howl } from 'howler';

const FADE_LENGTH = 1000;

export default {
  initialize(soundsData) {
    let soundOptions;

    const soundNames = Object.getOwnPropertyNames(soundsData);

    this.sounds = soundNames.reduce((memo, name) => {
      soundOptions = soundsData[name];

      // Allow strings instead of objects, for when all that is needed is a URL
      if (typeof soundOptions === 'string') {
        soundOptions = { src: [soundOptions] };
      }

      let howl = new Howl(soundOptions);
      if (soundOptions.finalVolume) {
        howl.finalVolume = soundOptions.finalVolume;
      }

      return { ...memo, [name]: howl };
    }, {});

    return this.sounds;
  },

  addSound(soundName, soundOptions) {
    // Allow strings instead of objects, for when all that is needed is a URL
    if (typeof soundOptions === 'string') {
      soundOptions = { src: [soundOptions] };
    }

    this.sounds[soundName] = new Howl(soundOptions);
  },

  play(soundName, spriteName, noOverlay = false) {
    const sound = this.sounds[soundName];

    if (typeof sound === 'undefined') {
      return console.warn(`
        The sound '${soundName}' was requested, but soundMiddleware doesn't have anything registered under that name.
      `);
    } else if (spriteName && typeof sound._sprite[spriteName] === 'undefined') {
      const validSprites = Object.keys(sound._sprite).join(', ');

      return console.warn(`
        The sound '${soundName}' was found, but it does not have a sprite specified for '${spriteName}'.
        It only has access to the following sprites: ${validSprites}.
      `);
    }

    if (!noOverlay) {
      sound.play(spriteName);
    } else if (!sound.playing()) {
      sound.play(spriteName);
    }
  },

  fadeIn(soundName) {
    const sound = this.sounds[soundName];

    if (typeof sound === 'undefined') {
      return console.warn(`
        The sound '${soundName}' was requested, but soundMiddleware doesn't have anything registered under that name.
      `);
    }

    if (!sound.playing()) {
      sound.fade(0, sound.finalVolume || 1, FADE_LENGTH);
    }
  },

  fadeOutAndStop(soundName) {
    const sound = this.sounds[soundName];

    if (typeof sound === 'undefined') {
      return console.warn(`
        The sound '${soundName}' was requested, but soundMiddleware doesn't have anything registered under that name.
      `);
    }

    sound.fade(sound.finalVolume || 1, 0, FADE_LENGTH);
    sound.once('fade', () => sound.stop());
  }
};



// WEBPACK FOOTER //
// ./src/utils/howlerIntegration.js